import { render, staticRenderFns } from "./KcsDetail.vue?vue&type=template&id=3bcf6dad&"
import script from "./KcsDetail.vue?vue&type=script&lang=js&"
export * from "./KcsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports